// extracted by mini-css-extract-plugin
module.exports = {"main":"_2Zni6p","container":"_3k-BCT","mobile":"DIEN-y","title":"_3oajxZ","text":"waOME6"};